


















































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { storeBedManagement } from "@/store/modules/BedManagementStore";
import BedManagementSvc from "@/services/BedManagementService";
import { userModule } from "@/store/modules/user";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import { composeDate, toDateString } from "@/utils/asesmenIntensifDateTime";
import {
  BedManagementChecklist,
  BedManagementListFilter,
  BedManagementMppOption,
  BedManagementRekapMode,
  BedManagementRow
} from "@/types/bedManagement";

@Component({ components: { VCDateTimePicker, UnitRuangPicker } })
export default class BedManagementListPage extends Vue {
  filter = {
    mode: "bulanan" as BedManagementRekapMode,
    periode: "",
    tanggal_dari: "",
    tanggal_sampai: "",
    unit_id: null as string | null,
    mpp_user_id: null as number | null,
    evaluasi: null as "sudah" | "belum" | null
  };

  evaluasiOpts = [
    { text: "Sudah dievaluasi", value: "sudah" },
    { text: "Belum dievaluasi", value: "belum" }
  ];

  modeOpts = [
    { text: "Tanggal", value: "harian" },
    { text: "Bulan", value: "bulanan" },
    { text: "Tahun", value: "tahunan" },
    { text: "Rentang tanggal", value: "rentang" }
  ];

  mppOpts: BedManagementMppOption[] = [];
  mengunduh = false;

  pagination = {
    page: 1,
    itemsPerPage: 15
  };

  headers = [
    { text: "Tanggal", value: "tanggal" },
    { text: "Pukul", value: "pukul", sortable: false },
    { text: "MPP", value: "mpp", sortable: false },
    { text: "Unit terkait", value: "unit_terkait", sortable: false },
    { text: "Problem", value: "problem", sortable: false, align: "center" },
    { text: "Tatalaksana", value: "tatalaksana", sortable: false, align: "center" },
    { text: "Evaluasi", value: "evaluasi", sortable: false },
    { text: "Aksi", value: "actions", sortable: false, align: "end" }
  ];

  dialogHapus = false;
  hapusTarget: BedManagementRow | null = null;
  menghapus = false;

  get items() {
    return storeBedManagement.items;
  }

  get loading() {
    return storeBedManagement.loading;
  }

  get meta() {
    return storeBedManagement.meta;
  }

  get canCreate(): boolean {
    return userModule.hasPrivilege("mpp_bed_management", "create");
  }

  get tahunOpts(): string[] {
    const kini = new Date().getFullYear();
    const out: string[] = [];
    for (let i = 0; i <= 5; i++) out.push(String(kini - i));
    return out;
  }

  get tanggalPeriode(): Date | null {
    return composeDate(this.filter.periode, "00:00");
  }

  set tanggalPeriode(val: Date | null) {
    this.filter.periode = toDateString(val) || "";
  }

  get tanggalDari(): Date | null {
    return composeDate(this.filter.tanggal_dari, "00:00");
  }

  set tanggalDari(val: Date | null) {
    this.filter.tanggal_dari = toDateString(val) || "";
  }

  get tanggalSampai(): Date | null {
    return composeDate(this.filter.tanggal_sampai, "00:00");
  }

  set tanggalSampai(val: Date | null) {
    this.filter.tanggal_sampai = toDateString(val) || "";
  }

  mounted() {
    this.filter.periode = this.periodeDefault();
    this.muatOpsiMpp();
    this.fetch();
  }

  @Watch("pagination", { deep: true })
  onPagination() {
    this.fetch();
  }

  @Watch("filter.mode")
  onModeChange() {
    this.filter.tanggal_dari = "";
    this.filter.tanggal_sampai = "";
    this.filter.periode = this.periodeDefault();
    this.applyFilter();
  }

  periodeDefault(): string {
    const kini = new Date();

    if (this.filter.mode === "harian") return toDateString(kini) || "";
    if (this.filter.mode === "tahunan") return String(kini.getFullYear());
    if (this.filter.mode === "rentang") return "";

    const bulan = String(kini.getMonth() + 1).padStart(2, "0");
    return `${kini.getFullYear()}-${bulan}`;
  }

  get paramPeriode(): BedManagementListFilter {
    const params: BedManagementListFilter = { mode: this.filter.mode };

    if (this.filter.mode === "rentang") {
      if (this.filter.tanggal_dari) params.tanggal_dari = this.filter.tanggal_dari;
      if (this.filter.tanggal_sampai) params.tanggal_sampai = this.filter.tanggal_sampai;
    } else if (this.filter.periode) {
      params.periode = this.filter.periode;
    }

    if (this.filter.unit_id) params.unit_id = this.filter.unit_id;
    if (this.filter.mpp_user_id) params.mpp_user_id = this.filter.mpp_user_id;

    return params;
  }

  get periodeSiap(): boolean {
    return this.filter.mode === "rentang"
      ? !!this.filter.tanggal_dari && !!this.filter.tanggal_sampai
      : !!this.filter.periode;
  }

  fetch() {
    if (!this.periodeSiap) return;

    const params: BedManagementListFilter = {
      ...this.paramPeriode,
      page: this.pagination.page,
      per_page: this.pagination.itemsPerPage
    };
    if (this.filter.evaluasi) params.evaluasi = this.filter.evaluasi;
    storeBedManagement.fetchList(params);
  }

  async muatOpsiMpp() {
    try {
      const res = await BedManagementSvc.rekapFilterOptions();
      this.mppOpts = res.data?.data?.mpp || [];
    } catch {
      // ErrorAlert 
    }
  }

  async unduhExcel() {
    this.mengunduh = true;
    try {
      await BedManagementSvc.downloadExcel(this.paramPeriode);
    } catch {
      // ErrorAlert 
    } finally {
      this.mengunduh = false;
    }
  }

  applyFilter() {
    this.pagination.page = 1;
    this.fetch();
  }

  resetFilter() {
    this.filter.tanggal_dari = "";
    this.filter.tanggal_sampai = "";
    this.filter.unit_id = null;
    this.filter.mpp_user_id = null;
    this.filter.evaluasi = null;
    this.filter.periode = this.periodeDefault();
    this.applyFilter();
  }

  createNew() {
    this.$router.push({ name: "bed-management-form", params: { id: "baru" } });
  }

  openForm(id: number) {
    this.$router.push({ name: "bed-management-form", params: { id: String(id) } });
  }

  printPdf(id: number) {
    BedManagementSvc.printPdf(id);
  }

  confirmHapus(item: BedManagementRow) {
    this.hapusTarget = item;
    this.dialogHapus = true;
  }

  async hapus() {
    if (!this.hapusTarget) return;
    this.menghapus = true;
    try {
      await BedManagementSvc.destroy(this.hapusTarget.id);
      this.dialogHapus = false;
      this.hapusTarget = null;
      this.fetch();
    } catch {
      // ErrorAlert 
    } finally {
      this.menghapus = false;
    }
  }

  jumlahIsian(checklist: BedManagementChecklist | null): number {
    if (!checklist) return 0;
    const pilihan = Array.isArray(checklist.pilihan) ? checklist.pilihan.length : 0;
    return pilihan + (checklist.lainnya ? 1 : 0);
  }

  formatDate(d: string | null) {
    if (!d) return "-";
    const [y, m, day] = d.split("-");
    return `${day}-${m}-${y}`;
  }

  formatDt(dt: string | null) {
    if (!dt) return "";
    const [tanggal, jam] = dt.split(" ");
    return `${this.formatDate(tanggal)} ${(jam || "").substring(0, 5)}`;
  }
}
